export const useMockApi = (window as any)?.bootstrap?.useMockApi;

const apiEnvironment = (window as any)?.bootstrap?.apiEnvironment;

const dev2: ApiEndpoints = {
	personPrc: 'https://enterprise-apitest.cpg.org:443/d2/person-prc/1.0/client/person',

	organizationPrc: 'https://enterprise-apitest.cpg.org:443/d2/organization-prc/1.0/client/organization',

	miscPrc: 'https://enterprise-apitest.cpg.org/d2/misc-prc/1.0',

	benAdmin: 'https://enterprise-apitest.cpg.org/d2/benadmin-prc/1.0',

	mlps: 'https://enterprise-apitest.cpg.org/d2/ghl-prc/1.0',

	wam: 'https://enterprise-apitest.cpg.org/d2/wam-prc/1.0/external_api',

	notification: 'https://enterprise-apitest.cpg.org/d2/notification-prc/1.0/notification',

	myCpgPod: 'https://enterprise-apitest.cpg.org/d2/mycpg-prc/1.0',

	reportPrc: 'https://enterprise-apitest.cpg.org/d2/reports-prc/1.0',

	domoUrl: 'https://domo-dev2.cpg.org/api/card?',

	contentApi: 'https://cpg-tcsm-r3-4-dev.adagetech.net',

	changeLogApi: 'https://enterprise-apitest.cpg.org/d2/event-audit-prc/1.0',

	clergyBioApi: 'https://enterprise-apitest.cpg.org/d2/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://enterprise-apitest.cpg.org:443/d2/person-prc/1.0/admin/client/person',

	
	cicApi: 'https://enterprise-apitest.cpg.org/d2/osscr-client/api',
};

const test1: ApiEndpoints = {
	personPrc: 'https://enterprise-apitest.cpg.org:443/t1/person-prc/1.0/client/person',

	organizationPrc: 'https://enterprise-apitest.cpg.org:443/t1/organization-prc/1.0/client/organization',

	miscPrc: 'https://enterprise-apitest.cpg.org/t1/misc-prc/1.0',

	benAdmin: 'https://enterprise-apitest.cpg.org/t1/benadmin-prc/1.0',

	mlps: 'https://enterprise-apitest.cpg.org/t1/ghl-prc/1.0',

	wam: 'https://enterprise-apitest.cpg.org/t1/wam-prc/1.0/external_api',

	notification: 'https://enterprise-apitest.cpg.org/t1/notification-prc/1.0/notification',

	myCpgPod: 'https://enterprise-apitest.cpg.org/t1/mycpg-prc/1.0',

	reportPrc: 'https://enterprise-apitest.cpg.org/t1/reports-prc/1.0',

	domoUrl: 'https://domo-test.cpg.org/api/card?',

	contentApi: 'https://test.cpg.org',

	changeLogApi: 'https://enterprise-apitest.cpg.org/t1/event-audit-prc/1.0',

	clergyBioApi: 'https://enterprise-apitest.cpg.org/t1/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://enterprise-apitest.cpg.org:443/t1/person-prc/1.0/admin/client/person',

	cicApi: 'https://enterprise-apitest.cpg.org/t1/osscr-client/api',

};

const test2: ApiEndpoints = {
	personPrc: 'https://apitest.cpg.org/t2/person-prc/1.0/client/person',

	organizationPrc: 'https://apitest.cpg.org/t2/organization-prc/1.0/client/organization',

	miscPrc: 'https://apitest.cpg.org/t2/misc-prc/1.0',

	benAdmin: 'https://apitest.cpg.org/t2/benadmin-prc/1.0',

	mlps: 'https://apitest.cpg.org/t2/ghl-prc/1.0',

	wam: 'https://apitest.cpg.org/t2/wam-prc/1.0/external_api',

	notification: 'https://apitest.cpg.org/t2/notification-prc/1.0/notification',

	myCpgPod: 'https://apitest.cpg.org/t2/mycpg-prc/1.0',

	reportPrc: 'https://apitest.cpg.org/t2/reports-prc/1.0',

	domoUrl: 'https://domo-qa.cpg.org/api/card?',

	contentApi: 'https://test.cpg.org',

	changeLogApi: 'https://apitest.cpg.org/t2/event-audit-prc/1.0',

	clergyBioApi: 'https://apitest.cpg.org/t2/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://enterprise-apitest.cpg.org/t2/person-prc/1.0/admin/client/person',

	cicApi: 'https://apitest.cpg.org/t2/osscr-client/api',

};

const sandbox: ApiEndpoints = {
	personPrc: 'https://apitest.cpg.org/sbox/person-prc/1.0/client/person',

	organizationPrc: 'https://apitest.cpg.org/sbox/organization-prc/1.0/client/organization',

	miscPrc: 'https://apitest.cpg.org/sbox/misc-prc/1.0',

	benAdmin: 'https://apitest.cpg.org/sbox/benadmin-prc/1.0',

	mlps: 'https://apitest.cpg.org/sbox/ghl-prc/1.0',

	wam: 'https://apitest.cpg.org/sbox/wam-prc/1.0/external_api',

	notification: 'https://apitest.cpg.org/sbox/notification-prc/1.0/notification',

	myCpgPod: 'https://apitest.cpg.org/sbox/mycpg-prc/1.0',

	reportPrc: 'https://apitest.cpg.org/sbox/reports-prc/1.0',

	domoUrl: 'https://domo.cpg.org/api/card?',

	contentApi: 'https://qatest.cpg.org',

	changeLogApi: 'https://apitest.cpg.org/sbox/event-audit-prc/1.0',

	clergyBioApi: 'https://apitest.cpg.org/sbox/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://apitest.cpg.org/sbox/person-prc/1.0/admin/client/person',

	cicApi: 'https://apitest.cpg.org/sbox/osscr-client/api',

};

const prod: ApiEndpoints = {

	personPrc: 'https://ea-api.cpg.org:443/person-prc/1.0/client/person',

	organizationPrc: 'https://ea-api.cpg.org:443/organization-prc/1.0/client/organization',

	miscPrc: 'https://ea-api.cpg.org/misc-prc/1.0',

	benAdmin: 'https://ea-api.cpg.org/benadmin-prc/1.0',

	mlps: 'https://ea-api.cpg.org/ghl-prc/1.0',

	wam: 'https://ea-api.cpg.org/wam-prc/1.0/external_api',

	notification: 'https://ea-api.cpg.org/notification-prc/1.0/notification',

	myCpgPod: 'https://ea-api.cpg.org/mycpg-prc/1.0',

	reportPrc: 'https://ea-api.cpg.org/reports-prc/1.0',

	domoUrl: 'https://domo.cpg.org/api/card?',

	contentApi: 'https://www.cpg.org',

	changeLogApi: ' https://ea-api.cpg.org/event-audit-prc/1.0',

	clergyBioApi: 'https://ea-api.cpg.org/mycpg-prc/1.0/clergybio/self_service',

	personPrcAdmin: 'https://ea-api.cpg.org:443/person-prc/1.0/admin/client/person',

	cicApi: 'https://ea-api.cpg.org/osscr-client/api',

};


interface ApiEndpoints {
	personPrc: string;
	organizationPrc: string;
	miscPrc: string;
	benAdmin: string;
	mlps: string;
	wam: string;
	notification: string;
	myCpgPod: string;
	reportPrc: string;
	domoUrl: string;
	contentApi: string;
	changeLogApi: string;
	clergyBioApi: string;
	personPrcAdmin?: string;
	cicApi?: string;
}

const ApiEndPoints = {
	dev2,
	test1,
	test2,
	sandbox,
	prod,
};

const defaultApi = 'dev2';

export const ApiEndpoint = ApiEndPoints[apiEnvironment || defaultApi] as ApiEndpoints;